import { Font, StyleSheet } from '@react-pdf/renderer';

Font.register({
  family: 'Lato',
  fonts: [
    { src: '/Lato-Regular.ttf', fontWeight: 400 },
    { src: '/Lato-Bold.ttf', fontWeight: 700 },
  ],
});

export const styles = StyleSheet.create({
  page: {
    display: 'flex',
    flexDirection: 'row',
    width: '100%',
    height: '100%',
  },
  leftColumn: {
    position: 'relative',
    width: '50%',
    height: '100%',
    backgroundColor: '#0F91AE',
    color: 'white',
    justifyContent: 'center',
    alignItems: 'center',
    padding: 20,
  },
  rightColumn: {
    width: '50%',
    height: '100%',

    justifyContent: 'flex-start',
    alignItems: 'flex-start',
    paddingTop: 340,
    paddingLeft: 120,
    paddingRight: 40,
  },

  about: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 400,
    lineHeight: 1.3,

    marginTop: 20,
    marginBottom: 40,
    width: '70%',
  },
  image: {
    position: 'absolute',
    top: 35,
    left: '56%',
    width: 720,
    objectFit: 'contain',
    zIndex: 2,
  },
  peopleImage: {
    position: 'absolute',
    bottom: -130,
    left: 0,
    width: '100%',
    height: '100%',
    objectFit: 'contain',
    zIndex: 2,
  },
  highlightedText: {
    color: '#27343d',
    fontFamily: 'Lato',
    fontSize: 18,
    fontWeight: 700,
    textTransform: 'uppercase',
    marginBottom: 10,
  },
  title: {
    color: 'black',
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 700,
    textTransform: 'uppercase',
    marginBottom: 3,
  },
  subtitle: {
    color: 'white',
    fontFamily: 'Lato',
    fontSize: 14,
    fontWeight: 400,
  },
});
